import React, { useState } from 'react'
import { useQuery } from '@apollo/client'
import get from 'lodash/get'
import { Box, Text, getPaletteColor } from 'pcln-design-system'
import { NotificationImage } from '@pcln/notification'
import styled from 'styled-components'
import { numberOfViewersQuery } from '../../services/flexDates'
import { logSearchError } from '../../util/clientLogger'
import { APOLLO_CLIENT_NAME } from '@mfs/client/common/constants/constants'
import airPriceGuideRequests from '../../services/flexDates/queries/retailQuery'

const StyledBox = styled(Box)`
  display: none;
  ${(props) => props.theme.flyQueries.tablet} {
    display: block;
  }
`

const ViewersFlyIn = ({ returningFrom, travelDate, defaultFilterAirports, isIE }) => {
  // Display the component if the flexDates API results has more than 40 viewers
  const MIN_NUM_OF_VIEWERS = 40
  const [showBanner, setShowBanner] = useState(true)
  const { cityCode, airportCode } = returningFrom
  let destinationName = returningFrom.cityName

  const isDefaultAirports = !!defaultFilterAirports && defaultFilterAirports.length > 0
  if (cityCode !== airportCode && isDefaultAirports) {
    destinationName = get(defaultFilterAirports, '[0].destinationAirports[0].primaryLabel', '')
  }

  let apolloNumViewers

  const numViewersQuery = numberOfViewersQuery({
    cityCode,
    airportCode,
    travelDate,
  })

  const { data, error } = useQuery(airPriceGuideRequests.apolloClientAirPriceGuideNumViewers, {
    variables: { input: numViewersQuery },
    context: {
      headers: {
        'apollographql-client-name': APOLLO_CLIENT_NAME,
        'apollographql-client-version': globalThis.PCLN_BOOTSTRAP_DATA?.appVersion || 'development',
      },
    },
  })
  if (error) {
    const errorObject = {
      action: 'Apollo Client Flex Dates viewers',
      errorMessage: JSON.stringify(error),
    }
    logSearchError('Apollo Client Flex Dates viewers', errorObject)

    return null
  }
  if (data?.airPriceGuide?.viewers) {
    apolloNumViewers = data?.airPriceGuide?.viewers
  }

  const dismissBanner = () => {
    setShowBanner(false)
  }

  const headerContent = () => {
    return (
      <Text mr={3} bold color='text.base'>
        Book before prices go up!
      </Text>
    )
  }

  const bodyContent = () => {
    return (
      <Text regular>
        <Text.span bold>{Number(apolloNumViewers).toLocaleString()} </Text.span>
        people are searching for flights to {destinationName}.
      </Text>
    )
  }
  if (showBanner && apolloNumViewers >= MIN_NUM_OF_VIEWERS && isDefaultAirports && !isIE) {
    return (
      <StyledBox>
        <NotificationImage
          data-test='flex-dates-flyin-viewers'
          renderHeaderContent={headerContent}
          renderDynamicContent={bodyContent}
          handleCloseClick={dismissBanner}
          animationDelay={'16'}
          imageUrl='https://s1.pclncdn.com/design-assets/fly-images/guests.png'
          leftBarColor={getPaletteColor('alert.base')}
          bottom={true}
        />
      </StyledBox>
    )
  }

  return null
}

export { ViewersFlyIn }
